import { z } from 'zod';

export enum ResourceType {
    USER = 'USER',
    SYSTEM_SETTINGS = 'SYSTEM_SETTINGS',
    SYSTEM_USER_ROLE = 'SYSTEM_USER_ROLE',
    SYSTEM_USER_GROUP = 'SYSTEM_USER_GROUP',
    SYSTEM_USER_GROUP_ROLE_ASSIGNMENT = 'SYSTEM_USER_GROUP_ROLE_ASSIGNMENT',

    NONE = 'NONE',

    SYSTEM_ANNOUNCEMENT = 'SYSTEM_ANNOUNCEMENT',
    SYSTEM_ANNOUNCEMENT_USER_DISMISSAL = 'SYSTEM_ANNOUNCEMENT_USER_DISMISSAL',

    PROJECT = "PROJECT",
    PROJECT_VERSION = "PROJECT_VERSION",
    PROJECT_VERSION_PUBLISHMENT = "PROJECT_VERSION_PUBLISHMENT",
    STANDARD = "STANDARD",
    ROLE = "ROLE",
    PROCESS_AREA_ROLE_RELATION = "PROCESS_AREA_ROLE_RELATION",
    TOOL = "TOOL",
    VERIFICATION_METRIC = "VERIFICATION_METRIC",
    PROCESS_ARTIFACT = "PROCESS_ARTIFACT",
    ACTIVITIES = "ACTIVITIES",
    ACTIVITIES_MODEL = "ACTIVITIES_MODEL",
    CRITERIA = "CRITERIA",
    METHOD = "METHOD",
    OBJECTIVE = "OBJECTIVE",
    USE_CASE = "USE_CASE",
    USE_CASE_STANDARD_ASSOCIATION = "USE_CASE_STANDARD_ASSOCIATION",
    USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION = "USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION",
    V_CYCLE_ELEMENT = "V_CYCLE_ELEMENT",
    V_CYCLE_ELEMENT_CONTAINER = "V_CYCLE_ELEMENT_CONTAINER",
    V_CYCLE_ELEMENT_DECORATOR = "V_CYCLE_ELEMENT_DECORATOR",
    V_CYCLE_ELEMENT_CONTAINER_FILTER = "V_CYCLE_ELEMENT_CONTAINER_FILTER",
    GRID_ELEMENT_DECORATOR = "GRID_ELEMENT_DECORATOR",
    GRID_ELEMENT = "GRID_ELEMENT",
    WORKFLOW_REPRESENTATION = "WORKFLOW_REPRESENTATION",
    PROCESS_AREA = "PROCESS_AREA",
    PROCESS_AREA_CRITERIA_ASSOCIATION = "PROCESS_AREA_CRITERIA_ASSOCIATION",
    PROCESS_AREA_METHOD_ASSOCIATION = "PROCESS_AREA_METHOD_ASSOCIATION",
    PROCESS_AREA_OBJECTIVE_ASSOCIATION = "PROCESS_AREA_OBJECTIVE_ASSOCIATION",
    PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION = "PROCESS_AREA_PROCESS_ARTIFACT_ASSOCIATION",
    PROCESS_AREA_ROLE_ASSOCIATION = "PROCESS_AREA_ROLE_ASSOCIATION",
    PROCESS_AREA_TOOL_ASSOCIATION = "PROCESS_AREA_TOOL_ASSOCIATION",
    PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION = "PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION",
    PROCESS_AREA_ACTIVITIES_ASSOCIATION = "PROCESS_AREA_ACTIVITIES_ASSOCIATION",
    IMAGE_ATTACHMENT = "IMAGE_ATTACHMENT",
    VIDEO_ATTACHMENT = "VIDEO_ATTACHMENT",
    VIDEO_ATTACHMENT_CONTENT = "VIDEO_ATTACHMENT_CONTENT",

    CONTENT = "CONTENT",
    CONTENT_SECTION = "CONTENT_SECTION",
    CONTENT_SECTION_CONTENT = "CONTENT_SECTION_CONTENT",

    PROJECT_USER_ROLE = 'PROJECT_USER_ROLE',
    PROJECT_USER_GROUP = 'PROJECT_USER_GROUP',
    PROJECT_USER_GROUP_ROLE_ASSIGNMENT = 'PROJECT_USER_GROUP_ROLE_ASSIGNMENT',
}

export const ResourceTypeSchema = z.enum(ResourceType);
